import React, { useState } from 'react';
import { Form, Input, Button, Typography, message, Space } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { CognitoUser } from 'amazon-cognito-identity-js';
import UserPool from '../../utils/userPool';
import useTranslation from '../../hooks/useTranslation';

const { Title } = Typography;

const ConfirmEmailPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [email] = useState(location.state?.email || '');

    const onFinish = (values) => {
        const { code } = values;
        const user = new CognitoUser({
            Username: email,
            Pool: UserPool,
        });

        user.confirmRegistration(code, true, (err) => {
            if (err) {
                message.error(t('auth.confirmFailed', { message: err.message }));
                return;
            }
            message.success(t('auth.confirmSuccess'));
            navigate('/login');
        });
    };

    const handleResendCode = () => {
        const user = new CognitoUser({
            Username: email,
            Pool: UserPool,
        });

        user.resendConfirmationCode((err) => {
            if (err) {
                message.error(t('auth.resendFailed', { message: err.message }));
                return;
            }
            message.success(t('auth.resendSuccess'));
        });
    };

    return (
        <div style={{ maxWidth: 400, margin: 'auto', padding: '2rem' }}>
            <Title level={3} style={{ textAlign: 'center' }}>{t('auth.confirmEmailTitle')}</Title>
            <Form onFinish={onFinish} layout="vertical">
                <Form.Item
                    name="code"
                    rules={[{ required: true, message: t('auth.confirmationCodeRequired') }]}
                >
                    <Input
                        prefix={<SafetyOutlined />}
                        placeholder={t('auth.confirmationCode')}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        {t('auth.confirmEmail')}
                    </Button>
                </Form.Item>
                <Space direction="horizontal" style={{ justifyContent: 'space-between', width: '100%' }}>
                    <Button type="text" onClick={() => navigate('/login')}>
                        {t('auth.backToLogin')}
                    </Button>
                    <Button type="text" onClick={handleResendCode} disabled={!email}>
                        {t('auth.resendCode')}
                    </Button>
                </Space>
            </Form>
        </div>
    );
};

export default ConfirmEmailPage;
